export const mapTagSuggestions = (
  suggestionsResponse?: { suggestions?: string[] } | string[],
): TagOption[] => {
  const suggestionsArray = Array.isArray(suggestionsResponse)
    ? suggestionsResponse
    : suggestionsResponse?.suggestions;

  if (!suggestionsArray) {
    return [];
  }

  return suggestionsArray
    .filter((suggestion) => typeof suggestion === 'string' && suggestion.trim().length > 0)
    .map((suggestion) => ({
      key: suggestion,
      label: suggestion,
    }));
};
